module.exports = __webpack_public_path__ + "Storyboard.jpg?24c9fc949616d1ee4f28b7b9d8567da9";


//////////////////
// WEBPACK FOOTER
// ./static/Storyboard.jpg
// module id = 92
// module chunks = 0